import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { SupportTicketCreateFormPopperProps } from "models/propTypes/supportIssuePropTypes";
//#endregion
//#region components
import useSupportTicketCreateDialog from "./useCreateDialog";
import { PopperForm } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SupportTicketCreateFormPopper: React.FC<SupportTicketCreateFormPopperProps> = (props) => {
  const { getDialog: getSupportTicketCreateDialog } = useSupportTicketCreateDialog();
  const supportDialog = getSupportTicketCreateDialog(
    props.onSubmit,
    undefined,
    props.defaultMessage,
    undefined,
    props.onFormUpdate
  );
  return (
    <PopperForm
      {...props}
      {...supportDialog}
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.ContactSupport)}
      subTitle={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.ContactSupportText)}
    >
      {supportDialog.children as React.ReactElement}
    </PopperForm>
  );
};

export default SupportTicketCreateFormPopper;
